<template>
  <div class="subscription-table-component">
    <v-card flat>
      <v-data-table
        :loading="loading"
        loading-text="Loading subscriptions"
        :headers="headers"
        :items="subscriptions"
        item-key="id"
        :search="search"
        sort-by="unit.alias"
        @click:row="openSubscription"

      >

        <template v-slot:top>
          <v-toolbar flat v-if="header || hasSearch">
            <v-toolbar-title  v-if="header">{{header}}</v-toolbar-title>
            <v-spacer v-if="header"/>
            <v-text-field
              v-model="search"
              v-if="hasSearch"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
          </v-toolbar>
          <v-alert v-if="error" text dense type="error">
            {{ error }}
          </v-alert>
        </template>
        <template v-slot:item.unit.transientFamily="{ item }">
            <v-icon>{{getFamilyIcon(item.unit.transientFamily)}}</v-icon>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import familyIcon from '../mixins/familyIcon'

export default {
  name: 'ExpandableSubscriptionList',
  mixins: [familyIcon],
  props: {
    subscriptions: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    hasSearch: {
      type: Boolean,
      default: false
    },
    header: {
      type: String,
      default: ''
    }
  },
  components: {
  },
  data: () => ({
    search: '',
    headers: [
      {
        text: '',
        align: 'start',
        value: 'unit.transientFamily',
        sortable: false
      },
      {
        text: 'Alias',
        value: 'unit.alias'
      },
      {
        text: 'Note',
        value: 'unit.notes'
      },
      {
        text: 'Subscription number',
        value: 'subscriptionNumber'
      }
    ]
  }),
  methods: {
    openSubscription: function (event) {
      if ((this.currentSubscription.id === null) || (event.id !== this.currentSubscription.id)) {
        this.$router.push({ name: 'subscription', params: { subscriptionId: event.id } })
      }
    }
  },
  computed: {
    currentSubscription: function () {
      return this.$store.state.subscription.currentSubscription.data
    }
  }
}
</script>

<style scoped>
</style>
